module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/onesence-7-83b6d348ec93a78f78b6e0cc40359fe9.webp";